var React = require('react');

function Right (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.219668 0.219668C0.512558 -0.0732225 0.987438 -0.0732225 1.28033 0.219668L5.5303 4.46967C5.8232 4.76256 5.8232 5.23744 5.5303 5.53033L1.28033 9.7803C0.987438 10.0732 0.512558 10.0732 0.219668 9.7803C-0.0732225 9.4874 -0.0732225 9.0126 0.219668 8.7197L3.93934 5L0.219668 1.28033C-0.0732225 0.987438 -0.0732225 0.512558 0.219668 0.219668Z","fill":"currentColor"}));
}

Right.defaultProps = {"viewBox":"0 0 6 10","fill":"none"};

module.exports = Right;

Right.default = Right;
